import vue from "../../main";

export default class Role {
  name = "";
  description = "";
  auth_items = [];
  nameRules = [v => (v != null && v.length > 0) || vue.$t("global.error.required"), v => v.length >= 5 || "Nazwa musi mieć minimum 5 znaków"];

  load(name) {
    vue.axios.get("settings/auth-admin/role-details?id=" + encodeURIComponent(name)).then(resp => {
      this.name = resp.data.name;
      this.description = resp.data.description;
      this.auth_items = resp.data.auth_items;
    });
  }

  save() {
    return new Promise((resolve, reject) => {
      vue.axios
        .post("settings/auth-admin/role-save", this)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }
}
